import { BaseResponse } from '../../models/comm-http/responses/BaseResponse';

import { Component } from '@angular/core';

import {  BillingRecurringTypes, UpgradableProductsResponseArray, UpgradableProductsResponse } from 'app/models/ss-api/responses/upgradable.products.response';
import { SelectItem } from 'primeng/api';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { UpgradeProductRequest } from 'app/models/ss-api/requests/upgrade.product.request';
import { ssApiService } from 'app/services/ss-api.service';

export interface IChangeBillingCycleDialogModel {
  title: string;
  subTitle: string;
  message: string;
  upgradeProducts: UpgradableProductsResponseArray;
  CreditCards: SelectItem[];
  SelectedCreditCard: SelectItem;
  LicenseKey: string;
}

@Component({
  selector: 'change-billing-cycle-dialog',
  styleUrls: ['./change-billing-cycle-dialog.component.css'],
  templateUrl: './change-billing-cycle-dialog.component.html'
})
export class ChangeBillingCycleDialogComponent implements IChangeBillingCycleDialogModel {


  confirmTitle: string = 'Upgrade Product';
  confirmMessage: string = 'You are about to upgrade a product subscription. Your credit card will be billed.';

  successTitle: string = 'Product upgraded';
  successMessage: string = 'Your purchase was successfull.';

  errorTitle: string = 'Error';
  errorMessage: string = 'We were not able to process this request. Try again later or use a different credit card.';

  cancelledTitle: string = 'Cancelled';
  cancelledMessage: string = 'You cancelled this upgrade.';



  title: string;
  subTitle: string;
  message: string;
  upgradeProducts: UpgradableProductsResponseArray;
  CreditCards: SelectItem[];
  SelectedCreditCard: SelectItem;

  SelectedProduct: UpgradableProductsResponse = new UpgradableProductsResponse();
  SelectedProductLock: boolean = true;
  PurchaseDisabled: boolean = true;
  Initals: string = '';
  LicenseKey: string = '';
  UpgradeDisabled: boolean;
  result: any;

  constructor(private api: ssApiService) {
  }

  close() {

  }

  ProductSelectionChanged(product: UpgradableProductsResponse) {
    this.SelectedProduct = product;
    this.SelectedProductLock = false;
    this.CheckPurchaseDisabled();
  }


  BillingTypeToString(type: BillingRecurringTypes) {
    return BillingRecurringTypes[type];
  }

  BillingTypeToPerString(type: BillingRecurringTypes) {
    if (type == BillingRecurringTypes.Monthly)
      return 'per Month';
    else
      return 'per Year';
  }


  CreditCardChanged(item: SelectItem) {

  }



  InitialsChanged(data: string) {
    this.CheckPurchaseDisabled();
  }

  CheckPurchaseDisabled() {
    // if (this.Initals != "" && !this.SelectedProductLock)
    if (!this.SelectedProductLock)
      this.PurchaseDisabled = false;
    else
      this.PurchaseDisabled = true;
  }

  SelectedBillingCycleToString(): string {

    switch (this.SelectedProduct.BillingCycle) {

      case BillingRecurringTypes.Monthly:
        return 'month';

      case BillingRecurringTypes.Yearly:
        return 'year';

      default:
        return 'unimplemented';
    }

  }

  private UpgradeProduct(): Promise<any> {

    if (this.SelectedCreditCard == undefined)
      // we didn't change the credit card selection
      this.SelectedCreditCard = this.CreditCards[0];

    let request = new UpgradeProductRequest();
    request.CreditCardID = Number(this.SelectedCreditCard);
    request.Initials = this.Initals;
    request.LicenseKey = this.LicenseKey;
    request.NewBillingCycle = this.SelectedProduct.BillingCycle;
    request.NewProductID = this.SelectedProduct.ProductID;
    request.SimulateOnly = false; // for debug

    return this.api.ProductsUpgrade(request)
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        this.result = response.Result;
        return response;
      });
  }

  ProcessOrder(): Promise<any> {
    // confirm
    return Swal.fire({
      title: this.confirmTitle,
      text: this.confirmMessage,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes, order!',
      cancelButtonText: 'No, cancel',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // try to order
        return this.UpgradeProduct();
      }
    });

  }

  async confirm() {
    this.result = true;

    await this.ProcessOrder().then(
      (response: any) => {

        // init dialog vars
        let cType = 'success';
        let cTitle = this.successTitle;
        let cMessage = this.successMessage;

        if (response.isDismissed) {
          cType = 'error';
          cTitle = this.cancelledTitle;
          cMessage = this.cancelledMessage;
        } else if (!response.value || !response.value.Result) {
          // not ok
          cType = 'error';
          cTitle = this.errorTitle;
          cMessage = this.errorMessage;
        }

        // show result
        Swal.fire(
          {
            title: cTitle,
            text: cMessage,
            icon: cType as SweetAlertIcon,
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          })
          .then(() => { }, () => { }); // keep this line to prevent promise error;

      },
      (dismiss) => {
        if (dismiss === 'cancel') {
          this.result = false;

          if (!confirm)
            return;

          // show cancelled
          Swal.fire({
            title: this.cancelledTitle,
            text: this.cancelledMessage,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000
          })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
        }
      });

    this.close();
  }




  cancel() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.result = false;
    this.close();
  }

}
